// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"3a8da190","361":"4930cc8d","708":"cb711080","926":"fd1eef34"}[chunkId] + ".chunk.css";
};